import React, { useEffect, useRef } from 'react';
import './KodanshaOffers.scss';
import KodenshaFreeToReadHome from './KodenshaFreeToReadHome';
import { FreeMode, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as T } from 'swiper/types';
import { useWindowSize } from '../Hooks/useWindowSize';
import { useAtom, useAtomValue } from 'jotai';
import { LoginAtom, LoginStatus } from '../../store/AccountStore';
import { fetchSpotlight } from '../../store/SpotlightStore';

const KodanshaOffers = (): JSX.Element => {
    const SwiperRef = useRef<T>();
    const { width } = useWindowSize();
    const loginStatus = useAtomValue(LoginAtom);
    const [data, fetch] = useAtom(fetchSpotlight);

    useEffect(() => {
        fetch();
    }, []);


    if (!data) {
        return null;
    }

    console.log('data.spotlights', data);

    return (
        <section className='spotlight-container'>
            <div className='title-wrapper'>
                <span className='offers-container-header-1' style={{marginBottom: !data[0].kicker ? '5px' : '0'}}>
                    {/*{loginStatus === "LoggedIn" ? 'Limited Spotlight Series' : 'Free with Reader Account'}*/}
                    {loginStatus === "LoggedIn" ? 'Limited Spotlight Series' : data[0]?.title ?? 'Free with Reader Account'}
                </span>
                <span className='offers-container-header-2'>
                    {/*{loginStatus === "LoggedIn" ? 'Read volumes 1-3 for FREE' : 'Get exclusive access to volumes 1-3'}*/}
                    {loginStatus === "LoggedIn" ? 'Read volumes 1-3 for FREE' : data[0].kicker ?? 'Get exclusive access to volumes 1-3'}
                </span>
            </div>

            <div className={'spotlight-items'}>
            <Swiper
                spaceBetween={15}
                slidesPerView={2}
                slidesPerGroup={2}
                freeMode={true}
                modules={[FreeMode, Pagination]}
                onSwiper={(swiper) => {
                    SwiperRef.current = swiper;
                }}
                navigation={{
                    prevEl: '.prev',
                    nextEl: '.next',
                }}
                breakpoints={{
                    320: {
                        slidesPerView: 1.2,
                        slidesPerGroup: 1,
                    },
                    480: {
                        slidesPerView: 1.4,
                        slidesPerGroup: 1,
                    },
                    576: {
                        slidesPerView: 1.7,
                        slidesPerGroup: 1,
                    },
                    768: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                    },
                }}
            >
                {data[0]?.spotlights?.map((item, index) => {
                    if (width > 768 && index > 1) {
                        return null;
                    }

                    return <SwiperSlide key={index}>
                        <div className='ItemContainer'>
                            <KodenshaFreeToReadHome id={item.series?.id}
                                                    title={item.seriesTitle}
                                                    readerId={item.readerId}
                                                    src={item.imageUrl ?? item.series.thumbnails[0]?.url}
                                                    author={item.author}
                                                    limit={item.informationNote}
                                                    color={item.colorOverlay ?? item.series.thumbnails[0]?.color}
                                                    description={item.series?.description}
                                                    rest={item}
                            />
                        </div>
                    </SwiperSlide>;
                })}
            </Swiper>
            </div>
        </section>
    );
};

export default KodanshaOffers;
